@import 'apps/webcomponents/src/assets/style-helpers.scss';

:host {
  --search-input-height: 54px;
}

.list {
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;

  &--search {
    padding: calc(1.5 * var(--spacer)) var(--spacer);
  }

  &--title {
    padding: var(--spacer);
    color: var(--main-titles-inputs-600);
    background: var(--white-layout-301-level-0-elevation);
  }

  &--options {
    padding: 0 var(--spacer);
    flex: 1;
    overflow: auto;
    max-height: var(--gz-enum-max-height, none);

    .option {
      --font-family: var(--font-family-secondary);
      &.hidden {
        display: none;
      }
    }
  }

  &--no-results {
    text-align: center;
    display: none;
    padding: calc(var(--spacer) * 3) 0;
    line-height: 18px;
    color: var(--chart-302-icon-buttons-titles);

    &.visible {
      display: block;
      font-family: var(--font-family-secondary);
      color: var(--chart-302-icon-buttons-titles);
    }
  }
}

:host(.enum-filter-list) {
  .list {
    max-height: var(--enum-filter-content-max-height);

    &--search {
      display: none;
      position: absolute;
      width: 100%;
      height: var(--search-input-height);
      top: 0;
    }

    &.has-search {
      padding-top: var(--search-input-height);

      .list {
        &--search {
          display: block;
        }
      }
    }
  }
}

.list-group {
  border-bottom: none;
  &.border-bottom {
    border-bottom: 1px solid var(--chart-100-pressed);
  }

  &--title {
    color: var(--chart-300-icon-buttons);
    padding: 13px 0;
  }

  &--no-results {
    text-align: center;
    padding: var(--spacer) 0 3px;
    line-height: 18px;
    color: var(--chart-302-icon-buttons-titles);
  }

  &:has(+ #emptyTemplate) {
    border-bottom: none;
  }
}

:host([grouptype='accordion']) {
  .accordion-group {
    margin-bottom: -1px;
    --margin--compact-accordion: 0;
    overflow-x: hidden;
  }
  .list--options {
    padding: 0 4px 0 var(--spacer);
    overflow-x: hidden;
  }
}
